import config from "config";
import { authGetJson, authPostJson } from "utilities/msalFetches";
import { throwIfResponseError } from "apis/apiUtilities";
import {
  IGetSystemAccessRequestResponse,
  IManageUserDetail,
  IMySystemAccessRequestResponse,
  ISubmitSystemAccessRequestApproval
} from "interfaces/user/UserInterfaces";
import {
  formatGetSystemAccessResponse,
  formatMySystemAccessRequestResponse,
  formatSystemAccessRequest,
  formatSystemAccessRequestApproval
} from "./systemAccessRequestFormatter";

class SystemAccessRequestApi {
  public async submitSystemAccessRequest(roleAssignments: IManageUserDetail[], requestReason: string): Promise<boolean> {
    let response = await authPostJson(
      config.endpoints.systemAccessRequests.submitSystemAccessRequest,
      JSON.stringify(formatSystemAccessRequest(roleAssignments, requestReason)),
    );

    await throwIfResponseError(response);

    return true;
  }
  
  public async getSystemAccessRequest(
    systemAccessRequestId: number
  ): Promise<IGetSystemAccessRequestResponse> {
    let response = await authGetJson(
      config.endpoints.systemAccessRequests.getSystemAccessRequest.replace(
        "{id}",
        systemAccessRequestId.toString()
      )
    );

    await throwIfResponseError(response);
    return formatGetSystemAccessResponse(await response.json());
  }

  public async submitSystemAccessRequestApproval(request: ISubmitSystemAccessRequestApproval): Promise<boolean> {
    let response = await authPostJson(
      config.endpoints.systemAccessRequests.submitSystemAccessRequestApproval,
      JSON.stringify(formatSystemAccessRequestApproval(request)),
    );

    await throwIfResponseError(response);
    return true;
  }

  public async getMySystemAccessRequest(): Promise<IMySystemAccessRequestResponse> {
    let response = await authGetJson(
      config.endpoints.systemAccessRequests.getMySystemAccessRequest
    );

    await throwIfResponseError(response);
    return formatMySystemAccessRequestResponse(await response.json());
  }
}

export default new SystemAccessRequestApi();